<template>
  <div class="d-flex flex-column align-center justify-center h-100 py-16">
    <div class="mt-32" :class="containerClass">
      <h2 class="text-center indigo--text text--darken-2">Store Payment</h2>
      <AccountPayment class="mt-8"></AccountPayment>
    </div>
  </div>
</template>

<script>
import AccountPayment from "@/views/Payment/Component/AccountPayment";

export default {
  name: "PaymentPage",
  components: {
    AccountPayment
  },
  computed: {
    containerClass() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 'container'
        case 'sm': return 'container-sm'
        case 'md': return 'container-md'
        case 'lg': return 'container-md'
        case 'xl': return 'container-md'
        default: return 'container-md'
      }
    }
  }
}
</script>

<style lang="scss" scoped>

.container {
  width: 90%
}

.container-sm {
  width: 75%;
}

.container-md {
  width: 55%
}

</style>